import React, { useState } from 'react';
import Draggable from 'react-draggable';
import useWindowWidth from '@hooks/useWindowWidth';

type Props = {
  children: JSX.Element[] | JSX.Element;
  className?: string;
  direction?: 'topRight' | 'bottomRight';
  onActivate?: () => void;
};
function DraggableWrapper({
  children,
  className,
  direction = 'topRight',
  onActivate,
}: Props) {
  const isMobile = useWindowWidth() < 480;

  const width =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const posMap = {
    topRight: { x: 0, y: 60 },
    bottomRight: { x: isMobile ? 0 : width - 396, y: 0 },
  };

  const [pos, setPos] = useState(posMap[direction]);

  function handleDrag(e, ui) {
    e.preventDefault();

    const { x, y } = pos;

    setPos({
      x: x + ui.deltaX,
      y: y + ui.deltaY,
    });
  }

  function handleStop(e) {
    e.preventDefault();
    const { x, y } = pos;
    setPos({
      x: x,
      y: y,
    });
  }

  function handleActivate() {
    onActivate?.();
  }

  return (
    <Draggable
      onDrag={handleDrag}
      onStop={handleStop}
      disabled={isMobile}
      bounds="parent"
      defaultClassName={className || 'music-player'}
      defaultPosition={{ x: pos.x, y: pos.y }}
      cancel=".resize-handler, button"
      onMouseDown={handleActivate}
    >
      {children}
    </Draggable>
  );
}

export default DraggableWrapper;
